<div class="modal-content">
  <div class="modal-header">
    <p *ngIf="companyEmployeeAdjustment" class="modal-title font-16 text-dark">{{ 'employees_policies_adjustements.page_title_edit' | translate }}</p>
    <p *ngIf="!companyEmployeeAdjustment" class="modal-title font-16 text-dark">{{ 'employees_policies_adjustements.page_title_create' | translate }}</p>
    <button (click)="activeModal.dismiss()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="font-24 text-muted"><i class="mdi mdi-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <form (ngSubmit)="onSubmit()" [formGroup]="adjustmentEditForm">
              <div class="row">
                <div class="col-12 text-right">
                  <small class="text-muted">
                    {{ 'company_employee_policies.adjustment_description' | translate }}
                  </small>
                </div>
              </div>
              <ng-container formArrayName="employee_datetime_types">
                <div *ngFor="let datetimeTypesForm of employeeDatetimeTypes?.controls; let index = index" [formGroupName]="index" class="row">
                  <div class="col-12 mt-2">
                    <label class="control-label">{{ employeePolicyDatetimes[index].name }} - {{ "company_employee_policies.hours" | translate }} </label>
                    <input
                        class="form-control"
                        formControlName="hours"
                        name="hours"
                        type="number"
                    >
                  </div>
                </div>
              </ng-container>
              <hr>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">{{ 'employees_policies_adjustements.effective_from' | translate }}</label>
                    <input [allowInput]="true" [altInput]="true" [disableMobile]="true" [locale]="locale$ | async" [minDate]="effectiveFromMinDate"
                           altFormat="d.m.Y"
                           class="form-control"
                           dateFormat="Y-m-d"
                           formControlName="effective_from"
                           mwlFlatpickr
                           name="effective_from" type="text">
                    <div *ngIf="submitted && f.effective_from.errors">
                      <p *ngIf="f.effective_from.errors.required" class="text-danger validation-text">
                        {{ 'angular_validation.field' | translate }} {{ 'employees_policies_adjustements.effective_from' | translate }}
                        {{ 'angular_validation.required' | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">{{ 'employees_policies_adjustements.description' | translate }}</label>
                    <input [ngxSummernote]="summernoteHelper.getSummernoteConfig()" formControlName="description" name="description" type="text">
                  </div>
                </div>
              </div>
              <div class="row mt-2 align-items-center">
                <div class="col-6 text-right">
                  <u (click)="deleteAdjustment()" *ngIf="companyEmployeeAdjustment?.employee_policy_adjustement_ID" class="text-muted">{{ 'employees_policies_adjustements.action_delete'  | translate }}</u>
                </div>
                <div class="col-6 text-right my-auto">
                  <button class="btn btn-success" type="submit">{{ 'employees_policies_adjustements.action_save' | translate }}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
